import React, {useState, useEffect} from 'react';
import * as css from './style.m.css';
import { Popover, Tooltip} from '@cloud/atom-ui';
import useMappedState from '@src/utils/useMappedState';
import {constants} from './constants';
import QuestionCircleOutlined from '@cloud/atom-ui-icons/QuestionCircleOutlined';

let enterStatus = false
export default () => {
  const {APPLY_PROVIDER, JION_TIGS} = constants;
  const {user, tenant = {}, siteType = {}} = useMappedState('root');
  const [userInfo, setUserInfo] = useState({});          //初始数据
  //未认证的弹窗
  const PopCard = (title, aText, name) => {
    return (<div className={css.popContainer}>
      <div>{title}</div>
      <div className={css.link} onClick={() => linkToURL(name)}>{aText}</div>
    </div>)
  };

  if (user && user.roles && user.roles.length > 0 && !enterStatus) {
    user.roles.forEach(function (item) {
      if (item.roleCode === "enterpriseAdmin") {
        enterStatus = true
      }
    })
  }

  //根据状态展示不同内容
  const creatISVDOM = (welinkMarketStatus, userInfo) => {
    switch (welinkMarketStatus) {
      case 0:
        return (
          <div className={css.account}>
            <div className={css.certification}>
              <div>未认证服务商</div>
              <Popover placement="topLeft"
                       content={PopCard(
                         "发布WeLink第三方企业应用，需进行华为云账号绑定，申请成为WeLink服务商",
                         "立即绑定",
                         "bindUrl"
                       )}
                       trigger="hover" arrowPointAtCenter>
                <QuestionCircleOutlined style={{margin: '9px 0 0 6px'}}
                      className="amu-headers-more-icon"
                />
              </Popover>
            </div>
          </div>
        );
      case 1:
      case 3:
        return (
          <div className={css.account}>
            <div className={css.certification}>
              <div>未认证服务商</div>
              <Popover placement="topLeft"
                       content={PopCard(
                         "发布WeLink第三方企业应用，需先申请成为WeLink服务商",
                         "立即申请",
                         "authUrl"
                       )}
                       trigger="hover" arrowPointAtCenter>
                <QuestionCircleOutlined style={{margin: '9px 0 0 6px',}}
                      className="amu-headers-more-icon"
                />
              </Popover>
            </div>
            {userInfo.cloudDomainName &&
            <>
              <div>已绑定华为云账号</div>
              <div style={{wordBreak: "break-all"}}>{userInfo.cloudDomainName}</div>
              <div className={css.changeBind} onClick={() => linkToURL("bindUrl")}>更换绑定</div>
            </>
            }
          </div>
        );
      case 2:
        return (
          <div className={css.account}>
            <div className={css.certification}>
              <div>已认证服务商</div>
            </div>
          </div>
        );
      default:
        return (
          <div className={css.account}>
            <div className={css.certification}>
              <div>未认证WeLink服务商</div>
            </div>
          </div>
        )
    }
  }

  //获得数据
  const tenantInfo = async () => {
    try {
      const res = await fetch(`/${process.env.REACT_APP_API_CONTEXT}/service/tenant/tenantInfo`, {method: "GET"});
      if (res.status == 1) {
        return res.data;
      } else {
        return {};
      }
    } catch (e) {
      return {};
    }
  }
  //获得链接
  const linkToURL = (name) => {
    tenantInfo().then(obj => {
      if (obj[name]) {
        window.open(obj[name]); //打开新页面
      }
    });
  }
  useEffect(() => {
    setUserInfo(tenant);
  }, [tenant.companyNameCn])

  return (
    <div id={css.certificationPart} className={css.certificationPart}>
      {
        (userInfo && user) ?
          <>
            <div className={css.companyName}>
              <img className={css.companyLogo} src={require('@src/assets/company.png')}/>
              <div className={css.companyTag}>
                <div className={css.companyTitle}>
                  <p className={css.name}>{userInfo.companyNameCn}</p>

                </div>
                <p className={css.email}>
                  {
                    userInfo.welinkMarketStatus == 2 ?
                      <p className={css.companyStatus}>已入驻</p>
                      :
                      siteType.site_type != 2 ?
                        <div className={css.noApply}>
                          <p className={css.notitle}>未入驻服务商<Tooltip placement="top"
                                                                    title={enterStatus ? APPLY_PROVIDER : JION_TIGS}
                                                                    overlayStyle={{
                                                                      maxWidth: "172px",
                                                                      width: "auto"
                                                                    }}><QuestionCircleOutlined style={{
                            marginLeft: '6px',
                            fontSize: '13px'
                          }}/></Tooltip></p>
                          {enterStatus && (userInfo.welinkMarketStatus == 1 || userInfo.welinkMarketStatus == 3) &&
                          <p className={css.apply} onClick={() => linkToURL("authUrl")}>立即入驻</p>}
                        </div>
                        : null
                  }
                </p>
              </div>
            </div>
            {
              siteType && siteType.site_type == 2 ? null
                : enterStatus &&
                (userInfo.cloudDomainName ?
                  <div className={css.account}>
                    <div className={css.accountName}>
                      <div className={css.title}>租户已绑定华为云账号</div>
                      <div className={css.name} style={{wordBreak: "break-all"}}>{userInfo.cloudDomainName}</div>
                    </div>
                    <div className={css.changeBind} onClick={() => linkToURL("bindUrl")}>更换绑定</div>
                  </div>
                  : <div className={css.account}>
                    <div className={css.accountName}>
                      <div className={css.title}>
                        租户未绑定华为云账号<Tooltip placement="top" title="申请入驻服务商时，请先绑定华为云账号"
                                           overlayStyle={{maxWidth: "126px", width: "126px"}}><QuestionCircleOutlined
                        style={{marginLeft: '6px', fontSize: '13px'}}/></Tooltip>
                      </div>
                    </div>
                    <div className={css.link} onClick={() => linkToURL("bindUrl")}>立即绑定</div>
                  </div>)

            }
          </> :
          null
      }
    </div>
  )
}
